import { isEqual } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Curso } from '../../../../models/usuario.model';
import { atualizaCurso } from '../../../../stores/curso/curso.store';
import { capitalizeTitulo } from '../../../../utils/formatters/capitalize-titulo/capitalize-titulo';
import { Modalidade } from '../../app-container.types';

export const useCourseSelection = (listaCurso: Curso[] | null, isLead: boolean | null) => {
  const DEFAULT_TIPO_CURSO = 'GRAD';
  const cursoSelecionadoLocal = localStorage.getItem('cursoSelecionado');
  const [tagSelecionada, setTagSelecionada] = useState(() => {
    if (isLead && cursoSelecionadoLocal) {
      return JSON.parse(cursoSelecionadoLocal).tipo ?? DEFAULT_TIPO_CURSO;
    }
    return DEFAULT_TIPO_CURSO;
  });
  const hasSetInitialTag = useRef(false);

  useEffect(() => {
    if (!hasSetInitialTag.current && listaCurso && listaCurso.length > 0) {
      const existe = listaCurso.some((curso) => curso.tipo === DEFAULT_TIPO_CURSO);
      setTagSelecionada(existe ? DEFAULT_TIPO_CURSO : 'POS');
      hasSetInitialTag.current = true;
    }
  }, [listaCurso]);

  const listaCursoFiltrada = useCallback(() => {
    if (!listaCurso) return [];
    const listaFiltrada = listaCurso.filter((curso) => curso.tipo === tagSelecionada);
    const listaCapitalizada = listaFiltrada.map((lista) => ({
      ...lista,
      nome: capitalizeTitulo(lista.nome),
    }));
    return listaCapitalizada.sort((a, b) => a.nome.localeCompare(b.nome));
  }, [listaCurso, tagSelecionada]);

  const selecionarCurso = useCallback(
    (item: Curso) => {
      if (isLead && item && !isEqual(item, JSON.parse(cursoSelecionadoLocal ?? '{}'))) {
        localStorage.setItem('cursoSelecionado', JSON.stringify(item));
        atualizaCurso(item);
      }
    },
    [isLead, cursoSelecionadoLocal],
  );

  const ordemTipos: Modalidade[] = [Modalidade.GRAD, Modalidade.POS, Modalidade.TEC];
  const tiposCompletos: Record<string, { label: string; value: string }> = {
    [Modalidade.GRAD]: { label: 'Graduação', value: 'GRAD' },
    [Modalidade.POS]: { label: 'Pós-Graduação', value: 'POS' },
    [Modalidade.TEC]: { label: 'Técnico', value: 'TEC' },
  };

  const tiposUnicos = listaCurso ? ordemTipos.filter((tipo) => listaCurso.some((curso) => curso.tipo === tipo)) : [];

  const tagPropsMapeadas = tiposUnicos.map((tipo) => ({
    id: `Tag${tiposUnicos.indexOf(tipo) + 1}`,
    label: tiposCompletos[tipo]?.label,
    value: tiposCompletos[tipo]?.value,
    name: 'type-select',
  }));

  return {
    tagSelecionada,
    setTagSelecionada,
    listaCursoFiltrada,
    selecionarCurso,
    tagPropsMapeadas,
  };
};
